export default __webpack_public_path__ + "static/media/BackWhite.f909fdae.svg";